import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  TextField,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Grid,
  InputAdornment,
  FormGroup, // Added for multiple discount selection
} from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { PosTabs } from './PosTabs';
import axios from 'axios';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppContext } from '../../config/AppContext';
import axiosWithAuth, { axiosWithCart } from '../../services/ServiceConfig';
import { getDeviceId } from '../../services/deviceId';
import CheckoutCart from './CheckoutCart';
import './Pos.scss';
import { makeStyles } from '@material-ui/core/styles';
import LocalStorageService from '../../services/LocalStorage/LocalStorage.service';
import { ArrowBack } from '@material-ui/icons';
import PromoService from '../../services/Promo/Promo.service';
import VenueService from '../../services/Venue/Venue.service';
import StoreService from '../../services/Store/Store.service';
import PrinterService from '../../services/Printer/Printer.service';
import CustomProduct from './CustomProduct/CustomProduct';
import { getCurrencyPrefix } from '../../services/Util/Util.service';
import InventoryService from '../../services/Inventory/Inventory.service';
import DialogContentText from '@material-ui/core/DialogContentText';
declare const ENVARS: any;
const useStyles = makeStyles({
  title: {
    color: '#474350',
    fontWeight: 'bold',
    fontSize: '24px',
    textAlign: 'center',
  },
  dialogTitle: {
    color: '#474350',
    fontWeight: 700,
    fontSize: '18px',
    borderBottom: '1px solid #e4e4e4',
    padding: '18px 24px',
  },
  closeButton: {
    color: '#6e6e6e',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#f7f7f7',
    },
    minWidth: '128px',
    minHeight: '44px',
    borderRadius: '8px',
    border: '1px solid #cacac9',
    textTransform: 'none',
    fontWeight: 600,
  },
  cancleDiscountButton: {
    color: '#6e6e6e',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#f7f7f7',
    },
    minWidth: '128px',
    minHeight: '44px',
    borderRadius: '8px',
    border: '1px solid #cacac9',
    textTransform: 'none',
    fontWeight: 600,
  },
  addToOrderButton: {
    color: '#fff',
    backgroundColor: '#009dc7',
    '&:hover': {
      backgroundColor: '#0086ab',
    },
    minWidth: '128px',
    minHeight: '44px',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
  },
  proceedButton: {
    color: '#fff',
    backgroundColor: '#009dc7',
    '&:hover': {
      backgroundColor: '#0086ab',
    },
    minWidth: '128px',
    minHeight: '44px',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
  },
  dialogActionsRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    padding: '16px 24px',
  },
  dialog: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogActions: {
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
  },
  checkboxLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  discountPinLabel: {
    color: '#009bc5',
    fontSize: '1.2rem',
    marginBottom: '0.5rem',
  },
  discountPinTextField: {
    borderBottom: '2px solid #009bc5',
  },
  InstructionField: {
    '& .MuiInputBase-root:hover': {
      borderColor: 'initial',
    },
    '& .MuiInputBase-root.Mui-focused': {
      borderColor: 'initial',
    },
    fontSize: '12px',
    fontFamily: 'Roboto, "Helvetica", Arial, sans-serif',
  },
});
function PosTerminal() {
  interface Terminal {
    id: string;
    image: null | string; // Update the type based on the actual data type
    isDeleted: boolean;
    isPOSCash: boolean;
    locationId: string;
    registrationCode: string;
    storeId: string;
    stripeTerminalId: string;
    terminalName: string;
    userId: string;
    venueId: string;
  }
  const history = useHistory();
  const {
    setStripeTerminal,
    stripeTerminal,
    cartItems,
    setCartItems,
    subTotal,
    selectedStoreId,
    setSelectedStoreId,
  } = useAppContext();
  const location: any = useLocation();
  setStripeTerminal(location?.state.item?.stripeTerminalId);
  const pdfRef = useRef();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isCheckoutDialogOpen, setIsCheckoutDialogOpen] = useState(false);
  const [isConfirmationDialog, setIsConfirmationDialog] = useState(false);
  const [isPosCash, setPosCash] = useState(false);
  const [order, setOrder] = useState<any>({});
  const [promo, setPromo] = useState<any[]>([]);
  const [discountApplied, setDiscountApplied] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [isOrderCompltedDialogOpen, setIsOrderCompltedDialogOpen] = useState(
    false,
  );
  const [isPrintDialogOpen, setIsPrintDialogOpen] = useState(false);
  const [iscashCompletedDialogOpen, setIsCashCompletedDialogOpen] = useState(
    false,
  );
  const [isAddOnDialogOpen, setIsAddOnDialogOpen] = useState(false);
  const [instructions, setInstructions] = useState('');
  const [product, setProduct] = useState<any>({});
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [outOfStockItems, setOutOfStockItems] = useState<any[]>([]);
  const [
    isPaymentConfirmationDialogOpen,
    setIsPaymentConfirmationDialogOpen,
  ] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [Productloading, setProductloading] = React.useState(false);
  const [addOnLoading, setAddOnLoading] = useState(false);
  const [processingTerminalId, setProcessingTerminalId] = useState(1);
  const [processingPaymentIntentId, setProcessingPaymentIntentId] = useState(1);
  const [isCardPayment, setIsCardPayment] = useState(false);
  const [cartId, setCartId] = useState('');
  const [finalAmount, setFinalAmount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [convenienceFee, setconvenienceFee] = useState(0);
  // Totals calculated by the server for the current cart. Card and cash payments use these
  // instead of rebuilding the amount in the browser, so the charge always matches the order.
  const [cartTotal, setCartTotal] = useState(0);
  const [cashTotal, setCashTotal] = useState(0);
  const userId = window.localStorage.getItem('userId');
  const storeId = window.localStorage.getItem('storeId');
  const classes = useStyles();
  const [isCashDialog, setIsCashDialog] = useState(false);
  const [isAmountError, setIsAmountError] = useState(false);
  const [enteredAmount, setEnteredAmount] = useState('0');
  const [returnAmount, setReturnAmount] = useState('0');
  const [cartDataIds, setCartDataIds] = useState({});
  const [showDiscounts, setShowDiscounts] = useState(false);
  const [selectedDiscount, setSelectedDiscount] = useState<string[]>([]); // Changed from string to string[]
  const [discountPin, setDiscountPin] = useState('');
  const [venueTaxCaluculated, setVenueTaxCalculated] = useState(false);
  const [customAmount, setCustomAmount] = useState(0);
  const [customPercentage, setCustomPercentage] = useState(0);
  const [showCustomDiscounts, setShowCustomDiscounts] = useState(false);
  const [storeDiscount, setStoreDiscount] = useState(false);
  const [terminal, setTerminal] = useState<Terminal | null>(null);
  const [showCustomProduct, setShowCustomProduct] = useState(false);
  const [storeData, setStoreData] = useState();
  const [venueData, setVenueData] = useState();
  const [fetchProducts, setFetchProducts] = useState(false);
  const [outOfStockPopUp, setOutOfStockPopUp] = useState(false);
  const [showNotePopup, setShowNotePopup] = useState(false);
  const [note, setNote] = useState('');
  const contentRef: any = useRef();
  const currencySymbol = getCurrencyPrefix((venueData as any)?.currency);
  const currentUrl = window.location.href;
  const [existingCart, setExistingCart] = useState<any>();
  const [showCartPopup, setShowCartPopup] = React.useState(false);

  const applyCartAmounts = (cart: any) => {
    setTaxAmount(venueTaxCaluculated ? cart.tax : 0);
    setconvenienceFee(cart.convenienceFee);
    setDiscountAmount(cart.discountAmt);
    setCartTotal(cart.total ?? 0);
    // Older API versions do not return cashTotal; fall back to their cash rule.
    setCashTotal(
      cart.cashTotal ??
        Math.max((cart.total ?? 0) - (cart.convenienceFee ?? 0), 0),
    );
  };
  const resetCartTotals = () => {
    setCartTotal(0);
    setCashTotal(0);
  };

  useEffect(() => {
    (async () => {
      if (cartId && storeId == selectedStoreId) {
        axiosWithCart
          .get(`cart/${cartId}`)
          .then(async response => {
            setCartItems(response.data.lineItems);
            setCartDataIds({
              storeId: response.data.storeId,
              venueId: response.data.venueId,
            });
            applyCartAmounts(response.data);
            if (customPercentage > 0 || customAmount > 0) {
              await handleCustomDiscountonUpdateCart(
                response.data.subTotal,
                response.data.lineItems.length,
              );
            }
          })
          .catch(error => {
            console.log('Error while addin g item to cart', error);
          })
          .catch(error => {
            console.log('Error while addin g item to cart', error);
          });
      }
      if (selectedStoreId) {
        const response: any = await StoreService.getStore(selectedStoreId);
        setStoreDiscount(response?.data?.customDiscount);
        setStoreData(response.data);
        setSelectedStoreId(selectedStoreId);
      }
      const check = window.localStorage.getItem('cartId');
      if (!check) {
        setCartItems([]);
        setTaxAmount(0);
        setconvenienceFee(0);
        resetCartTotals();
        setDiscountApplied(false);
        setDiscountAmount(0);
        setCustomPercentage(0);
        setCustomAmount(0);
        setSelectedDiscount([]);
      }
    })();
  }, [cartId, storeId]);

  useEffect(() => {
    const value: any = window.localStorage.getItem('cartId');
    if (value) {
      setCartId(value);
    }
  }, [cartItems]);
  useEffect(() => {
    VenueService.getVenue(location?.state.item?.venueId).then(resp => {
      setVenueTaxCalculated(resp.data?.calculateTaxes);
      setVenueData(resp.data);
    });
  }, [location?.state.item?.venueId]);

  useEffect(() => {
    if (stripeTerminal && selectedStoreId) {
      (async () => {
        const response: any = await axiosWithAuth.get(
          `terminals/store/${selectedStoreId}`,
        );
        if (response.data.length > 0) {
          const terminals = response.data;
          const matchingTerminal: any[] = terminals.filter((terminal: any) => {
            return terminal.stripeTerminalId === stripeTerminal;
          });
          if (matchingTerminal.length > 0) {
            setTerminal(matchingTerminal[0]);
          }
        }
      })();
    }
  }, [stripeTerminal]);

  const onClickCancel = () => {
    setLoading(true);
    // setLoading(true)
    const payload = {
      stripeTerminalId: stripeTerminal,
    };

    axiosWithAuth
      .post('terminals/cancel', payload)
      .then(response => {
        enqueueSnackbar('success', {
          variant: 'success',
        });
        setLoading(false);
      })
      .catch(error => {
        enqueueSnackbar('response', {
          variant: 'error',
        });
        console.log('Error while requesting process payment', error);
        setLoading(false);
      });
  };
  const onClickGetReader = () => {
    setLoading(true);

    axiosWithAuth
      .get(`terminals/get-readers/${stripeTerminal}`)
      .then(response => {
        enqueueSnackbar(response.data.label, {
          variant: 'success',
        });
        setLoading(false);
      })
      .catch(error => {
        enqueueSnackbar('error', {
          variant: 'error',
        });
        console.log('Error while requesting process payment', error);
        setLoading(false);
      });
  };
  const onClickReaderDisplay = () => {
    setLoading(true);
    axiosWithAuth
      .get(`terminals/status/${processingPaymentIntentId}`)
      .then((response: any) => {
        enqueueSnackbar(response?.data.message, {
          variant: 'success',
        });
        setLoading(false);
      })
      .catch(error => {
        enqueueSnackbar('response', {
          variant: 'error',
        });
        setLoading(false);
      });
  };
  const handleCheckoutDailog = async () => {
    if (cartItems.length > 0) {
      setFinalAmount(cartTotal);
      setIsCheckoutDialogOpen(!isCheckoutDialogOpen);
      // setIsCardPayment(false);
    } else {
      enqueueSnackbar('Please add items to cart first', {
        variant: 'warning',
      });
    }
  };
  const handleCheckoutDailogClose = () => {
    const payload = {
      stripeTerminalId: stripeTerminal,
      paymentIntenId: processingPaymentIntentId,
    };
    if (isCardPayment) {
      setLoading(true);
      axiosWithAuth
        .post('terminals/cancel', payload)
        .then(response => {
          setLoading(false);
          enqueueSnackbar('Process has been canceled successfully reader', {
            variant: 'success',
            autoHideDuration: 8000,
          });
        })
        .catch(error => {
          enqueueSnackbar('Could not cancel the process', {
            variant: 'error',
            autoHideDuration: 8000,
          });
          setLoading(false);
        });
    }
    setIsCheckoutDialogOpen(!isCheckoutDialogOpen);
    setIsCardPayment(false);
    setIsConfirmationDialog(false);
  };
  const handleCloseOrderComplete = () => {
    setIsOrderCompltedDialogOpen(false);
  };
  const handleInstructionsChange = (event: any) => {
    setInstructions(event.target.value);
  };
  const handleCheckboxChange = async (
    eId: string,
    itemId: string,
    productId: string,
  ) => {
    const selectedCategoryItems = selectedItems.filter(
      item => item.parentId === eId,
    );
    const selectedItemIndex = selectedCategoryItems.findIndex(
      item => item.id === itemId,
    );
    let newSelectedItems: any[] = [];

    if (selectedItemIndex !== -1) {
      // If the checkbox is already selected, remove it from the selectedItems array
      newSelectedItems = selectedCategoryItems.filter(
        (item, index) => index !== selectedItemIndex,
      );
    } else {
      // If the checkbox is not selected
      const category = product?.subCategories?.find(
        (subCategory: any) => subCategory.id === eId,
      );
      const selectionLimit = category?.selectionLimit;

      if (selectionLimit && selectedCategoryItems.length >= selectionLimit) {
        // If the selection limit has been reached, do not allow selecting more checkboxes
        return;
      }

      // Add the new checkbox to the selectedItems array
      newSelectedItems = [
        ...selectedCategoryItems,
        { id: itemId, parentId: eId },
      ];
    }

    setSelectedItems([
      ...selectedItems.filter(item => item.parentId !== eId),
      ...newSelectedItems,
    ]);
  };
  const handlecloseAddOn = () => {
    setIsAddOnDialogOpen(false);
    setSelectedItems([]);
  };
  const handleGenerateReceipt = async () => {
    try {
      order.venueTaxCaluculated = venueTaxCaluculated;
      order.terminalName = terminal?.terminalName;
      await PrinterService.PrintDocument(order);
    } catch (e) {
      enqueueSnackbar('Error While Printing Document', {
        variant: 'error',
        autoHideDuration: 8000,
      });
    } finally {
      await getProductIdsFromOrder();
      setIsPaymentConfirmationDialogOpen(false);
      setReturnAmount('0');
      setEnteredAmount('0');
      setIsCashCompletedDialogOpen(false);
      setIsOrderCompltedDialogOpen(false);
      setIsCheckoutDialogOpen(false);
      setCartItems([]);
      setTaxAmount(0);
      setconvenienceFee(0);
      resetCartTotals();
      setDiscountApplied(false);
      setDiscountAmount(0);
      setSelectedDiscount([]);
      enqueueSnackbar('order completed successfully', {
        variant: 'success',
        autoHideDuration: 8000,
      });
    }
  };
  const handlePaymentSuccessDailog = () => {
    setIsPaymentConfirmationDialogOpen(false);
    // setSubtotal(0)
  };
  const onClickCreditCard = () => {
    setLoading(true);
    const payload = {
      stripeTerminalId: stripeTerminal,
      currency: 'usd',
      payment_method_types: 'card_present',
      capture_method: 'manual',
      amount: subTotal,
    };

    axiosWithAuth
      .post('terminals/card-checkout', payload)
      .then(response => {
        setProcessingPaymentIntentId(
          response['data']['processPaymentIntentId'],
        );
        setProcessingTerminalId(response['data']['processTerminal']);
        setIsCardPayment(true);
        setLoading(false);
      })
      .catch(error => {
        console.log('Error while requesting card checkout', error);
      });
  };
  const onClickCreate = async () => {
    setLoading(true);
    const productsAlongQuantities = await filterProductWithQuantity();
    const responseHandleQuantity: any = await handleInventoryQuantity(
      productsAlongQuantities,
    );
    if (!responseHandleQuantity.success) {
      setLoading(false);
      return enqueueSnackbar(`${responseHandleQuantity.message}`, {
        variant: 'error',
        autoHideDuration: 8000,
      });
    }
    const payload = {
      stripeTerminalId: stripeTerminal,
      currency: 'usd',
      payment_method_types: 'card_present',
      amount: Number(cartTotal.toFixed(2)),
      cartDataIds: cartDataIds,
      cartId: cartItems[0]?.cartId,
      deviceId: getDeviceId(),
    };

    axiosWithAuth
      .post('terminals/create', payload)
      .then(response => {
        setProcessingPaymentIntentId(
          response['data']['processPaymentIntentId'],
        );
        setProcessingTerminalId(response['data']['processedTerminaltId']);
        setLoading(false);
        setIsCardPayment(true);
        enqueueSnackbar('amount has been successuly proccessed for reader', {
          variant: 'success',
          autoHideDuration: 8000,
        });
      })
      .catch(error => {
        enqueueSnackbar('Requires payment processing', {
          variant: 'error',
          autoHideDuration: 8000,
        });
        console.log('Error while requesting create payment', error);
        setLoading(false);
      });
  };
  const onClickPresent = () => {
    setLoading(true);
    const payload = {
      stripeTerminalId: stripeTerminal,
    };

    axiosWithAuth
      .post('terminals/present', payload)
      .then(response => {
        enqueueSnackbar(response.data.message, {
          variant: 'success',
          autoHideDuration: 8000,
        });
        setLoading(false);
      })
      .catch(() => {
        enqueueSnackbar('Amount in not processed yet', {
          variant: 'error',
          autoHideDuration: 8000,
        });
        setLoading(false);
      });
  };
  const onClickConfirm = () => {
    setLoading(true);
    // setLoading(true)
    const payload = {
      paymentIntenId: processingPaymentIntentId,
    };

    axiosWithAuth
      .post('terminals/confirm', payload)
      .then(response => {
        setLoading(false);
        enqueueSnackbar('response.data.message', {
          variant: 'success',
          autoHideDuration: 8000,
        });
      })
      .catch(error => {
        enqueueSnackbar('Payment method not found for this process', {
          variant: 'error',
          autoHideDuration: 8000,
        });
        console.log('Error while requesting present', error);
        setLoading(false);
      });
  };
  const onClickCapture = () => {
    setLoading(true);
    const createOrderPayload = {
      paymentIntentId: processingPaymentIntentId,
      terminalId: stripeTerminal,
      cartId: cartItems[0]?.cartId,
      payloadOrderType: 'POS',
      finalPrice: Number(cartTotal.toFixed(2)),
      tipAmt: 0,
    };
    if (note) {
      Object.assign(createOrderPayload, { note: note });
    }
    axios
      .post(`${ENVARS.API.BASE_URL}/api/v2/orders`, createOrderPayload, {
        method: 'POST',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${LocalStorageService.getLocalData(
            'authToken',
          )}`,
          'X-Device-Id': getDeviceId(),
        },
      })
      .then(async r => {
        setOrder(r.data);
        setLoading(false);
        setIsCheckoutDialogOpen(false);
        setIsPaymentConfirmationDialogOpen(false);
        setIsCardPayment(false);
        setLoading(false);
        setProcessingPaymentIntentId(1);
        setProcessingTerminalId(1);
        setCartItems([]);
        setTaxAmount(0);
        setconvenienceFee(0);
        resetCartTotals();
        setIsOrderCompltedDialogOpen(true);
        setPosCash(false);
        setNote('');
        enqueueSnackbar('Order has been placed successfully', {
          variant: 'success',
          autoHideDuration: 8000,
        });
        setIsCashCompletedDialogOpen(true);
        setCustomAmount(0);
        setCustomPercentage(0);
        setDiscountAmount(0);
        setSelectedDiscount([]); // Reset selected discounts
      })
      .catch(error => {
        console.log(error?.response?.data?.message, 'error?.message');
        enqueueSnackbar(error?.response?.data?.message, {
          variant: 'error',
          autoHideDuration: 8000,
        });
        console.log('Error while creating order', error);
        setLoading(false);
      });
  };
  const onClickCapturePayment = (val: any) => {
    setLoading(true);
    const payload = {
      processedTerminalId: processingTerminalId,
      processedPaymentId: processingPaymentIntentId,
      test: val,
    };
    axiosWithAuth
      .post('terminals/capture-payment', payload)
      .then(response => {
        setIsCheckoutDialogOpen(false);
        setIsPaymentConfirmationDialogOpen(true);
        setIsCardPayment(true);
        setLoading(false);
        setProcessingPaymentIntentId(1);
        setProcessingTerminalId(1);
        setCartItems([]);
      })
      .catch(error => {
        console.log('Error while requesting capture', error);
        setIsCheckoutDialogOpen(false);
        // setIsPaymentConfirmationDialogOpen(true)
      });
  };
  const onClickCash = async () => {
    const productsAlongQuantities = await filterProductWithQuantity();
    const responseHandleQuantity: any = await handleInventoryQuantity(
      productsAlongQuantities,
    );
    if (!responseHandleQuantity.success) {
      return enqueueSnackbar(`${responseHandleQuantity.message}`, {
        variant: 'error',
        autoHideDuration: 8000,
      });
    }
    setIsCheckoutDialogOpen(false);
    setIsCashDialog(true);
  };
  const onClickClearCart = async () => {
    if (cartId) {
      await axios.delete(`${ENVARS.API.BASE_URL}/api/v1/cart/${cartId}`);
    }
    window.localStorage.removeItem('cartId');
    setCartItems([]);
    setTaxAmount(0);
    setconvenienceFee(0);
    resetCartTotals();
    setDiscountApplied(false);
    setDiscountAmount(0);
    setCustomPercentage(0);
    setCustomAmount(0);
    setSelectedDiscount([]); // Explicitly reset selected discounts
  };
  const handleAddToBag = async () => {
    try {
      setAddOnLoading(true);
      if (selectedItems.length < 1) {
        await handleAddToCart(product, 1);
      } else {
        let subSelections = [];
        let parentIndex: any = {};

        for (let i = 0; i < selectedItems.length; i++) {
          if (selectedItems[i]?.id !== '') {
            let item = selectedItems[i];
            let parentId = item.parentId;

            if (parentId in parentIndex) {
              let parent = subSelections[parentIndex[parentId]];
              parent.subSelections.push({ id: item.id, quantity: 1 });
            } else {
              let parent = {
                subSelections: [{ id: item.id, quantity: 1 }],
                id: parentId,
              };
              parentIndex[parentId] = subSelections.length;
              subSelections.push(parent);
            }
          }
        }
        if (cartItems.length > 0) {
          const payload = {
            instructions: instructions,
            productId: product.id,
            quantity: 1,
            subSelections: subSelections,
          };

          const response = await axiosWithCart.post(
            `cart/${cartId}/items`,
            payload,
          );
          setCartItems(response?.data.lineItems);
          applyCartAmounts(response.data);
          setCartDataIds({
            storeId: response.data.storeId,
            venueId: response.data.venueId,
          });
          if (customPercentage > 0 || customAmount > 0) {
            await handleCustomDiscountonUpdateCart(
              response.data.subTotal,
              response.data.lineItems.length,
            );
          }
        } else {
          const payload = {
            userId: userId,
            storeId: selectedStoreId,
            deliveryLocationId: null,
            eventId: null,
            lineItem: {
              instructions: '',
              productId: product.id,
              quantity: 1,
              subSelections: subSelections,
            },
            orderType: 'POS',
            scheduledTime: '2023-04-27T10:00:00.000Z',
            gameDayOrder: true,
          };
          const response = await axiosWithCart.post('cart', payload);
          console.log(response, 'response++');
          setCartItems(response.data.lineItems);
          applyCartAmounts(response.data);
          if (customPercentage > 0 || customAmount > 0) {
            await handleCustomDiscountonUpdateCart(
              response.data.subTotal,
              response.data.lineItems.length,
            );
          }
          window.localStorage.setItem('cartId', response.data.id);
          setCartId(response.data.id);
          window.localStorage.setItem(
            'storeId',
            selectedStoreId ? selectedStoreId : '',
          );
        }
      }
      setIsAddOnDialogOpen(false);
      setSelectedItems([]);
      setAddOnLoading(false);
    } catch (error) {
      setAddOnLoading(false);
      enqueueSnackbar(error?.response?.data?.message, {
        variant: 'error',
        autoHideDuration: 8000,
      });
      console.log('Error while adding item to bag', error);
    }
  };
  const fetchProduct = async (itemId: String) => {
    const product = await axios.get(
      `${ENVARS.API.BASE_URL}/api/v1/products/${itemId}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${LocalStorageService.getLocalData(
            'authToken',
          )}`,
          'X-Device-Id': getDeviceId(),
        },
      },
    );
    const { data } = product;
    if (data?.subCategories?.length > 0) {
      for (let i = 0; i < data?.subCategories.length; i++) {
        const currentCategory: any = data?.subCategories[i];
        let activeSubProducts = [];
        for (let j = 0; j < currentCategory.subProducts.length; j++) {
          const { active } = currentCategory.subProducts[j];
          if (active) {
            activeSubProducts.push(currentCategory.subProducts[j]);
          }
        }
        data.subCategories[i].subProducts = activeSubProducts;
        if (data.subCategories[i].subProducts.length < 1) {
          data.subCategories.splice(i, 1);
          i--;
        }
      }
    }
    setProduct(product.data);
    return product.data;
  };

  const handleAddToCart = async (item: any, ind: number) => {
    try {
      const product: any = await fetchProduct(item.id);
      //check cart data Quantity
      if (product?.subCategories?.length > 0 && !isAddOnDialogOpen) {
        const newArray = product?.subCategories.flatMap((category: any) =>
          category.subProducts
            .filter(
              (subProduct: any) =>
                subProduct.autoSelect === true && subProduct.active === true,
            )
            .map((subProduct: any) => ({
              id: subProduct.id,
              parentId: category.id,
            })),
        );

        setSelectedItems(newArray);
        setIsAddOnDialogOpen(true);
      } else {
        setProductloading(true);
        if (cartItems.length > 0) {
          const payload = {
            productId: item.id,
            quantity: 1,
          };
          const response = await axiosWithCart.post(
            `cart/${cartId}/items`,
            payload,
          );
          setProductloading(false);
          setCartItems(response?.data.lineItems);
          applyCartAmounts(response.data);
          if (customPercentage > 0 || customAmount > 0) {
            await handleCustomDiscountonUpdateCart(
              response.data.subTotal,
              response.data.lineItems.length,
            );
          }
        } else {
          const payload = {
            userId: userId,
            storeId: selectedStoreId,
            deliveryLocationId: null,
            eventId: null,
            lineItem: { productId: item.id, quantity: 1 },
            orderType: 'POS',
            scheduledTime: '2023-04-27T10:00:00.000Z',
            gameDayOrder: true,
          };
          const response = await axiosWithCart.post('cart', payload);
          setCartItems(response.data.lineItems);
          applyCartAmounts(response.data);
          if (customPercentage > 0 || customAmount > 0) {
            await handleCustomDiscountonUpdateCart(
              response.data.subTotal,
              response.data.lineItems.length,
            );
          }
          window.localStorage.setItem('cartId', response.data.id);
          setCartId(response.data.id);
          window.localStorage.setItem(
            'storeId',
            selectedStoreId ? selectedStoreId : '',
          );
          setProductloading(false);
        }
      }
    } catch (error) {
      setProductloading(false);
      setIsAddOnDialogOpen(false);
      enqueueSnackbar(error?.response?.data?.message, {
        variant: 'error',
        autoHideDuration: 8000,
      });
    }
  };
  const removeFromCart = (ind: number, lineItemId: string, qty: number) => {
    axiosWithCart
      .put(`cart/${cartId}/items/${lineItemId}`, { quantity: 0 })
      .then(async response => {
        setCartItems(response.data.lineItems);
        applyCartAmounts(response.data);
        if (customPercentage > 0 || customAmount > 0) {
          await handleCustomDiscountonUpdateCart(
            response.data.subTotal,
            response.data.lineItems.length,
          );
        }
      })
      .catch(err => {
        const errorMessage =
          err.response?.data?.message || 'Failed to remove item from cart.';
        enqueueSnackbar(errorMessage, {
          variant: 'error',
          autoHideDuration: 8000,
        });
      });
  };

  const decrementFromCart = (ind: number, lineItemId: string, qty: number) => {
    axiosWithCart
      .put(`cart/${cartId}/items/${lineItemId}`, { quantity: qty - 1 })
      .then(async response => {
        setCartItems(response.data.lineItems);
        applyCartAmounts(response.data);
        if (customPercentage > 0 || customAmount > 0) {
          await handleCustomDiscountonUpdateCart(
            response.data.subTotal,
            response.data.lineItems.length,
          );
        }
      })
      .catch(err => {
        const errorMessage =
          err.response?.data?.message || 'Failed to update item quantity.';
        enqueueSnackbar(errorMessage, {
          variant: 'error',
          autoHideDuration: 8000,
        });
      });
  };

  const handleClick = (value: any) => {
    if (enteredAmount === '0') {
      setEnteredAmount(value);
    } else if (value === '.' && enteredAmount.toString().includes('.')) {
      return;
    } else if (value === '.' && !enteredAmount.toString().includes('.')) {
      setEnteredAmount(enteredAmount.toString() + value);
    } else {
      setEnteredAmount(enteredAmount.toString() + value);
    }
  };
  const calculateBill = async () => {
    const paidAmt = cashTotal;
    if (+enteredAmount < paidAmt) {
      setIsAmountError(true);
    } else {
      setIsAmountError(false);
      setReturnAmount((parseFloat(enteredAmount) - paidAmt).toFixed(2));
      await handleTransactionComplete();
    }
  };
  const handleTransactionComplete = async () => {
    setLoading(true);
    setIsCashCompletedDialogOpen(true);
    const createOrderPayload = {
      cartId: cartItems[0]?.cartId,
      finalPrice: Number(cashTotal.toFixed(2)),
      tipAmt: 0,
      taxAmount: taxAmount,
      payloadOrderType: 'POS_CASH',
      terminalId: stripeTerminal,
    };
    if (note) {
      Object.assign(createOrderPayload, { note: note });
    }
    axios
      .post(`${ENVARS.API.BASE_URL}/api/v2/orders`, createOrderPayload, {
        method: 'POST',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${LocalStorageService.getLocalData(
            'authToken',
          )}`,
          'X-Device-Id': getDeviceId(),
        },
      })
      .then(async r => {
        setIsCashDialog(false);
        setOrder(r.data);
        setCartItems([]);
        setTaxAmount(0);
        setconvenienceFee(0);
        resetCartTotals();
        setFinalAmount(0);
        setLoading(false);
        setPosCash(true);
        setDiscountAmount(0);
        setCustomPercentage(0);
        setCustomAmount(0);
        setSelectedDiscount([]); // Reset selected discounts
        setNote('');
      })
      .catch(error => {
        console.log('Error while creating order', error);
        setLoading(false);
        setIsCashCompletedDialogOpen(false);
        enqueueSnackbar(error?.response?.data?.message, {
          variant: 'error',
          autoHideDuration: 8000,
        });
      });
  };
  const onClickShowDiscountPopup = async () => {
    const { venueId, storeId } = location?.state.item;
    const { data } = await PromoService.storePromos(venueId, storeId);
    const updatedState = data.map((promo: any) => ({
      name: promo.code,
      price: promo.discountAmount,
      percent: promo.discountPercentage,
      type: promo.promotionCategory,
      productId: promo.product_id,
      productLimit: promo.productLimit,
    }));
    setPromo(updatedState);
    setShowDiscounts(true);
  };
  const onClickAddPromo = async () => {
    if (promo.length > 0 && selectedDiscount.length > 0) {
      const { venueId, storeId } = location?.state.item;
      axiosWithCart
        .post(`cart/${cartId}/promo`, {
          codes: selectedDiscount, // Changed from code to codes
          storeId: storeId,
          venueId: venueId,
        })
        .then(response => {
          applyCartAmounts(response.data);
          enqueueSnackbar('Promo added successfully', {
            variant: 'success',
            autoHideDuration: 8000,
          });
          setDiscountApplied(true);
          setShowDiscounts(false);
        })
        .catch(err => {
          const errorMessage =
            err.response?.data?.message ||
            'Failed to add promo or invalid promo';

          enqueueSnackbar(errorMessage, {
            variant: 'error',
            autoHideDuration: 8000,
          });
        });
      return;
    } else if (selectedDiscount.length === 0) {
      // If no discounts are selected, effectively remove all promos by sending empty array
      const { venueId, storeId } = location?.state.item;
      axiosWithCart
        .post(`cart/${cartId}/promo`, {
          codes: [],
          storeId: storeId,
          venueId: venueId,
        })
        .then(response => {
          applyCartAmounts(response.data);
          enqueueSnackbar('Promos cleared successfully', {
            variant: 'info',
            autoHideDuration: 8000,
          });
          setDiscountApplied(response.data.discountAmt > 0);
          setShowDiscounts(false);
        })
        .catch(err => {
          enqueueSnackbar('Failed to clear promos', {
            variant: 'error',
            autoHideDuration: 8000,
          });
        });
    }
  };

  const handleCustomDiscount = async () => {
    try {
      if (customPercentage > 0 || customAmount > 0) {
        setShowCustomDiscounts(false);
        const { venueId, storeId } = location?.state.item;
        const finalCustomValue = (
          (subTotal / 100) *
          Number(customPercentage)
        ).toFixed(2);
        if (customAmount > 0 && Number(customAmount) <= subTotal) {
          const response = await axiosWithCart.post(
            `cart/${cartId}/customDiscount`,
            {
              discountAmount: customAmount,
              storeId: storeId,
              venueId: venueId,
            },
          );
          applyCartAmounts(response.data);
          enqueueSnackbar('Discount Amount added successfully', {
            variant: 'success',
            autoHideDuration: 8000,
          });
          setDiscountApplied(true);
          setShowDiscounts(false);
          setSelectedDiscount([]); // Clear promo codes if custom is applied
        } else if (
          customPercentage > 0 &&
          Number(finalCustomValue) <= subTotal
        ) {
          const response = await axiosWithCart.post(
            `cart/${cartId}/customDiscount`,
            {
              discountAmount: finalCustomValue,
              storeId: storeId,
              venueId: venueId,
            },
          );
          applyCartAmounts(response.data);
          enqueueSnackbar('Discount Percentage added successfully', {
            variant: 'success',
            autoHideDuration: 8000,
          });
          setDiscountApplied(true);
          setShowDiscounts(false);
          setSelectedDiscount([]); // Clear promo codes if custom is applied
        } else {
          enqueueSnackbar('Discount should be less than the total', {
            variant: 'warning',
            autoHideDuration: 8000,
          });
        }
      }
    } catch (err) {
      setShowCustomDiscounts(true);
      enqueueSnackbar('Error While Handling Custom Discount', {
        variant: 'warning',
        autoHideDuration: 8000,
      });
    }
  };
  const handleCustomDiscountonUpdateCart = async (
    cartSubTotal: number,
    totalItems: number,
  ) => {
    try {
      const { venueId, storeId } = location?.state.item;
      if (totalItems < 1) {
        setDiscountApplied(false);
        setDiscountAmount(0);
        setCustomAmount(0);
        setCustomPercentage(0);
        setSelectedDiscount([]);
      } else {
        if (customPercentage > 0 || customAmount > 0) {
          setDiscountApplied(true);
          setShowDiscounts(false);
          // const { venueId, storeId } = location?.state.item; // Already defined above
          const finalCustomValue = (
            (cartSubTotal / 100) *
            Number(customPercentage)
          ).toFixed(2);
          if (customAmount > 0 && Number(customAmount) <= cartSubTotal) {
            const response = await axiosWithCart.post(
              `cart/${cartId}/customDiscount`,
              {
                discountAmount: customAmount,
                storeId: storeId,
                venueId: venueId,
              },
            );
            applyCartAmounts(response.data);
          } else if (
            customPercentage > 0 &&
            Number(finalCustomValue) <= cartSubTotal
          ) {
            const response = await axiosWithCart.post(
              `cart/${cartId}/customDiscount`,
              {
                discountAmount: finalCustomValue,
                storeId: storeId,
                venueId: venueId,
              },
            );
            applyCartAmounts(response.data);
          } else {
            // The server drops a custom discount that no longer fits the subtotal.
            setCustomAmount(0);
            setCustomPercentage(0);
            setDiscountApplied(false);
          }
        }
      }
    } catch (error) {
      enqueueSnackbar('Error While Handling Custom Discount', {
        variant: 'warning',
        autoHideDuration: 8000,
      });
    }
  };
  const handleDiscountSelection = (discountCode: string) => {
    setSelectedDiscount(prevSelected => {
      if (prevSelected.includes(discountCode)) {
        return prevSelected.filter(code => code !== discountCode);
      } else {
        return [...prevSelected, discountCode];
      }
    });
    setCustomPercentage(0);
    setCustomAmount(0);
  };
  const handleManagerPinChange = (event: any) => {
    setDiscountPin(event.target.value);
  };
  const onCashClose = () => {
    setReturnAmount('0');
    setIsAmountError(false);
  };
  const customDiscountHandleChange = (type: string, val: number) => {
    if (type === 'amount') {
      setCustomAmount(val);
      setCustomPercentage(0);
      setSelectedDiscount([]); // Reset promo codes
      return;
    }
    if (type === 'percentage') {
      setCustomPercentage(val);
      setCustomAmount(0);
      setSelectedDiscount([]); // Reset promo codes
      return;
    }
  };
  const handleFetchProducts = () => {
    setFetchProducts(true);
    setShowCustomProduct(false);
  };
  const handleFetchProductsFalse = () => {
    setFetchProducts(false);
    setShowCustomProduct(false);
  };
  const filterProductWithQuantity = async () => {
    const productQuantityDict: any = {};

    for (const item of cartItems) {
      if (!productQuantityDict[item.productId]) {
        productQuantityDict[item.productId] = {
          quantity: item.quantity || 0,
          name: item.name, // Add item name
        };
      } else {
        productQuantityDict[item.productId].quantity += item.quantity || 0;
      }

      for (const subSelectionCategory of item.subSelections) {
        for (const subSelection of subSelectionCategory.subSelections) {
          if (subSelection.productId) {
            if (!productQuantityDict[subSelection.productId]) {
              productQuantityDict[subSelection.productId] = {
                quantity: subSelection.quantity * item.quantity,
                name: subSelection.name, // Add subSelection name
              };
            } else {
              productQuantityDict[subSelection.productId].quantity +=
                subSelection.quantity * item.quantity;
            }
          }
        }
      }
    }
    const productQuantityArray = Object.keys(productQuantityDict).map(
      productId => ({
        productId,
        quantity: productQuantityDict[productId].quantity,
        name: productQuantityDict[productId].name,
      }),
    );
    return productQuantityArray;
  };
  const handleInventoryQuantity = async (Products: any[]) => {
    for (let i = 0; i < Products.length; i++) {
      const { productId, quantity, name } = Products[i];
      const currentProduct = await fetchProduct(productId);
      if (currentProduct && currentProduct?.countAsInventory) {
        const { data } = await InventoryService.getProductInventory(productId);
        if (data && data.active) {
          if (data.inventory_count < quantity) {
            return {
              success: false,
              message: name
                ? `${name} is out of stock`
                : 'item is out of stock',
            };
          }
        }
      }
    }
    return {
      success: true,
      message: `item avaialbe`,
    };
  };
  const getProductIdsFromOrder = async () => {
    const produtIds: any[] = [];
    for (let i = 0; i < order.lineItems.length; i++) {
      const currentItem: any = order.lineItems[i];
      if (!produtIds.includes(currentItem?.product?.id)) {
        produtIds.push(currentItem?.product?.id);
      }
      for (const subSelectionCategory of currentItem?.subSelections) {
        for (const subSelection of subSelectionCategory.subSelections) {
          if (
            subSelection?.productId &&
            !produtIds.includes(subSelection?.productId)
          ) {
            produtIds.push(subSelection?.productId);
          }
        }
      }
    }
    const outOfStockProducts: any[] = [];
    if (produtIds.length > 0) {
      for (let j = 0; j < produtIds.length; j++) {
        const currentProduct: any = await fetchProduct(produtIds[j]);
        if (
          currentProduct &&
          currentProduct.countAsInventory &&
          currentProduct.stock < 1
        ) {
          outOfStockProducts.push(currentProduct.name);
        }
      }
    }
    setOutOfStockItems(outOfStockProducts);
    if (outOfStockProducts.length > 0) {
      setFetchProducts(true);
      setOutOfStockPopUp(true);
    }
  };

  const onDeleteCart = async () => {
    try {
      if (cartId) {
        await axiosWithCart.delete(`/cart/${cartId}`);
      }
      setShowCartPopup(false);
      setExistingCart({});
      setCartItems([]);
      setAddOnLoading(false);
      setLoading(false);
      setProductloading(false);
      setSelectedDiscount([]); // Clear discounts on cart deletion
      setDiscountAmount(0);
      resetCartTotals();
      setCustomAmount(0);
      setCustomPercentage(0);
    } catch (error) {
      enqueueSnackbar('Error while Deleting Cart', {
        variant: 'error',
        autoHideDuration: 8000,
      });
      setShowCartPopup(false);
      setExistingCart({});
      setCartItems([]);
      setAddOnLoading(false);
      setLoading(false);
      setProductloading(false);
    }
  };

  return (
    <>
      {/* <div className="home"> */}
      {/* <Navbar /> */}
      <div className="main_container_pos">
        <header className="_heading_container">
          <span>{location?.state.item?.terminalName}</span>
          <button
            className="_top_secondaryBtn"
            onClick={() => history.goBack()}
          >
            Back to Manager Portal
          </button>
        </header>
        <div className="_tabs-cart-container">
          <div className="_tabs">
            <PosTabs
              fetchProducts={fetchProducts}
              handleFetchProductsFalse={handleFetchProductsFalse}
              addToCart={handleAddToCart}
              Productloading={Productloading}
            />
          </div>
          <div className="_cart">
            <CheckoutCart
              addToCart={handleAddToCart}
              removeItem={removeFromCart}
              decrementItem={decrementFromCart}
              taxAmount={taxAmount}
              selectedItems={selectedItems}
              discountAmount={discountAmount}
              convenienceFee={convenienceFee}
              onClickAddNote={() => setShowNotePopup(true)}
              hasNote={!!note}
              onClickDiscounts={onClickShowDiscountPopup}
            />
            <div className="_button_container">
              <div className="_button_container_left">
                <button
                  className="_button_addNote _button_addNote--outline"
                  onClick={() => {
                    setShowCustomProduct(true);
                  }}
                >
                  Add Custom Product
                </button>
              </div>
              <div className="_button_container_right">
                <button onClick={onClickClearCart} className="_button_clear">
                  Clear All
                </button>
                <button
                  className="_button_checkout"
                  onClick={handleCheckoutDailog}
                >
                  Checkout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={isCheckoutDialogOpen}
        // onClose={handleCheckoutDailog}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
          Select Payment Method
        </DialogTitle>
        <DialogContent style={{ padding: '32px 24px' }}>
          {loading ? (
            <div className="_payment_loading">
              <CircularProgress size={64} />
            </div>
          ) : isCardPayment ? (
            <div className="_payment_options">
              {!currentUrl.includes('https://venue.fanfoodapp.com') && (
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={onClickPresent}
                >
                  Test Payment
                </Button>
              )}
              <button className="_button_adjust" onClick={onClickCapture}>
                <span className="_payment_amount">Confirm Payment</span>
              </button>
            </div>
          ) : (
            <div className="_payment_options">
              {terminal?.isPOSCash ? (
                <button className="_button_adjust" onClick={onClickCash}>
                  <span className="_payment_amount">
                    ${cashTotal.toFixed(2)}
                  </span>
                  <span className="_payment_label">Cash</span>
                </button>
              ) : (
                <>
                  <button className="_button_view" onClick={onClickCreate}>
                    <span className="_payment_amount">
                      ${finalAmount.toFixed(2)}
                    </span>
                    <span className="_payment_label">Credit Card</span>
                  </button>
                  <button className="_button_adjust" onClick={onClickCash}>
                    <span className="_payment_amount">
                      ${cashTotal.toFixed(2)}
                    </span>
                    <span className="_payment_label">Cash</span>
                  </button>
                </>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', justifyContent: 'center' }}>
          <Button
            className={classes.cancleDiscountButton}
            disabled={loading}
            onClick={() =>
              isCardPayment
                ? setIsConfirmationDialog(true)
                : setIsCheckoutDialogOpen(false)
            }
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation diaglog to cancel process */}
      <Dialog
        open={isConfirmationDialog}
        // onClose={handleCheckoutDailog}
        aria-labelledby="form-dialog-title"
        // fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          id="form-dialog-title"
          style={{ textAlign: 'center', width: '100%' }}
        >
          Are you sure, you want to cancel the process ?
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <div style={{ textAlign: 'center' }}>
            <Button
              color="primary"
              variant="outlined"
              onClick={handleCheckoutDailogClose}
            >
              Yes
            </Button>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => setIsConfirmationDialog(false)}
            >
              No
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog open={iscashCompletedDialogOpen} maxWidth="sm" fullWidth>
        {loading ? (
          <div className="_receipt_loading">
            <CircularProgress size={64} />
          </div>
        ) : (
          <div className="_receipt_dialog">
            <div className="_receipt_header noPrint">
              <div className="_receipt_status_icon">
                <CheckCircleIcon />
              </div>
              <p className="_receipt_order_no">Order #{order?.orderNo}</p>

              {isPosCash ? (
                <div className="_receipt_payment_summary">
                  <div className="_receipt_payment_row">
                    <span>Payment Received</span>
                    <span className="_receipt_payment_value">
                      {`${currencySymbol}${parseFloat(enteredAmount).toFixed(
                        2,
                      )}`}
                    </span>
                  </div>
                  <div className="_receipt_change_due">
                    <span>Change Due to Customer</span>
                    <span className="_receipt_change_value">
                      {`${currencySymbol}${parseFloat(returnAmount).toFixed(
                        2,
                      )}`}
                    </span>
                  </div>
                </div>
              ) : (
                <p className="_receipt_success_text">
                  {`Payment of ${currencySymbol}${
                    order?.total ? order.total.toFixed(2) : 0
                  } captured successfully`}
                </p>
              )}
            </div>

            <div className="_receipt_body" ref={contentRef}>
              <div className="_receipt_customer">
                <div className="_receipt_row">
                  <span>Name</span>
                  <span>
                    {order?.user?.firstName} {order?.user?.lastName}
                  </span>
                </div>
                <div className="_receipt_row">
                  <span>Phone</span>
                  <span>{order?.user?.phoneNumber}</span>
                </div>
                <div className="_receipt_row">
                  <span>Time</span>
                  <span>
                    {new Date(order.createdTime).toLocaleDateString()}
                  </span>
                </div>
              </div>

              <div className="_receipt_divider" />

              <div className="_receipt_items">
                {order?.lineItems?.map((e: any, index: number) => (
                  <div key={index} className="_receipt_item">
                    <div className="_receipt_row">
                      <span>
                        {e?.name} ({e?.quantity}x{' '}
                        {`${currencySymbol}${e?.productPrice?.toFixed(2)}`})
                      </span>
                      <span>
                        {`${currencySymbol}${e?.total?.toFixed(2)}`}
                      </span>
                    </div>
                    {e?.subSelections?.length > 0 &&
                      e?.subSelections?.map((g: any, subIndex: number) =>
                        g?.subSelections?.map(
                          (f: any, nestedIndex: number) => (
                            <div
                              key={`${index}-${subIndex}-${nestedIndex}`}
                              className="_receipt_sub_item"
                            >
                              {f?.name}
                            </div>
                          ),
                        ),
                      )}
                  </div>
                ))}
              </div>

              <div className="_receipt_divider" />

              <div className="_receipt_totals">
                <div className="_receipt_row">
                  <span>Subtotal</span>
                  <span>
                    {`${currencySymbol}${order?.subTotal?.toFixed(2)}`}
                  </span>
                </div>
                {venueTaxCaluculated && (
                  <div className="_receipt_row">
                    <span>Sales Tax</span>
                    <span>
                      {`${currencySymbol}${order?.taxAmt?.toFixed(2)}`}
                    </span>
                  </div>
                )}
                {order?.discountAmt > 0 && (
                  <div className="_receipt_row">
                    <span>Discount</span>
                    <span>
                      {`- ${currencySymbol}${order?.discountAmt?.toFixed(
                        2,
                      )}`}
                    </span>
                  </div>
                )}
                {order?.convenienceFee > 0 && (
                  <div className="_receipt_row">
                    <span>POS Charges</span>
                    <span>
                      {`${currencySymbol}${order?.convenienceFee?.toFixed(
                        2,
                      )}`}
                    </span>
                  </div>
                )}
                <div className="_receipt_row _receipt_total_row">
                  <span>Order Total</span>
                  <span>
                    {`${currencySymbol}${order?.total?.toFixed(2)}`}
                  </span>
                </div>
              </div>
            </div>

            <div className="_receipt_footer noPrint">
              <Button
                onClick={async () => {
                  await getProductIdsFromOrder();
                  setReturnAmount('0');
                  setEnteredAmount('0');
                  setTaxAmount(0);
                  setconvenienceFee(0);
                  resetCartTotals();
                  setDiscountApplied(false);
                  setDiscountAmount(0);
                  setSelectedDiscount([]);
                  setIsCashCompletedDialogOpen(false);
                }}
                className={classes.closeButton}
              >
                Complete Order
              </Button>
              <Button
                onClick={handleGenerateReceipt}
                className={classes.proceedButton}
                autoFocus
              >
                Print Receipt
              </Button>
            </div>
          </div>
        )}
      </Dialog>

      <Dialog
        open={isAddOnDialogOpen}
        onClose={handlecloseAddOn}
        fullWidth
        PaperProps={{
          style: {
            margin: '0 0 9.3px',
            borderRadius: '13.1px',
            backgroundColor: '#fff',
            maxWidth: '60%',
          },
        }}
      >
        {addOnLoading ? (
          <div style={{ textAlign: 'center' }}>
            <CircularProgress size={100} />
          </div>
        ) : (
          <>
            <DialogTitle>
              <IconButton
                onClick={handlecloseAddOn}
                style={{ position: 'absolute', top: 0, right: 0 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <div>
              <DialogContent
                style={{
                  overflowY: 'auto',
                  position: 'relative',
                  paddingTop: 0,
                  paddingBottom: 20,
                }}
              >
                <div
                  style={{
                    flex: '1',
                    marginRight: '10px',
                    color: '#474350',
                    fontFamily: 'Roboto "Helvetica" Arial  sans-serif',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    lineHeight: '1.1',
                    letterSpacing: 'normal',
                    marginLeft: '15px',
                    wordWrap: 'break-word',
                    width: '330px',
                  }}
                >
                  {product?.name?.charAt(0)?.toUpperCase() +
                    product?.name?.slice(1)}
                </div>
                <div
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: 20,
                    height: '140px',
                    width: '160px',
                  }}
                >
                  <img
                    src={
                      product.imageUrl
                        ? product.imageUrl
                        : product.globalProduct &&
                          product.globalProduct.imageUrl
                    }
                    style={{
                      objectFit: 'contain',
                      maxHeight: '140px',
                    }}
                  />
                </div>
                <div
                  style={{
                    color: '#6e727cd9',
                    fontFamily: 'Roboto, "Helvetica", Arial, sans-serif',
                    fontSize: '14px',
                    marginTop: '10px',
                    marginLeft: '15px',
                    marginBottom: '25px',
                    wordWrap: 'break-word',
                    fontWeight: 'normal',
                    maxWidth: '40%',
                  }}
                >
                  {product.description ? product.description : ''}
                </div>
                <div
                  style={{
                    color: '#474350',
                    fontFamily: 'Roboto, "Helvetica", Arial, sans-serif',
                    fontSize: '14px',
                    marginTop: '50px',
                    marginLeft: '15px',
                    wordWrap: 'break-word',
                    fontWeight: 'bold',
                  }}
                >
                  {product?.category?.name?.toUpperCase()}
                </div>
                <div
                  style={{
                    fontFamily: 'Roboto, "Helvetica", Arial, sans-serif',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontStyle: 'normal',
                    lineHeight: '1.29',
                    letterSpacing: 'normal',
                    textAlign: 'left',
                    marginTop: '10px',
                    color: ' #474350',
                    maxHeight: '250px',
                    overflowX: 'scroll',
                    direction: 'rtl',
                  }}
                >
                  <div style={{ direction: 'ltr' }}>
                    {product?.subCategories?.length > 0 &&
                      product.subCategories.map((e: any, eIndex: number) => (
                        <div key={e.id}>
                          <p
                            style={{
                              color: '#474350',
                              fontFamily:
                                'Roboto, "Helvetica", Arial, sans-serif',
                              marginTop: '0px',
                              fontSize: '14px',
                              fontWeight: 'bold',
                              fontStretch: 'normal',
                              fontStyle: 'normal',
                              lineHeight: '1.29',
                              letterSpacing: 'normal',
                              textAlign: 'left',
                              marginLeft: '16px',
                              wordWrap: 'break-word',
                              marginBottom: '20px',
                            }}
                          >
                            {e?.name?.charAt(0)?.toUpperCase() +
                              e?.name?.slice(1)}
                            {e.required ? (
                              <span style={{ color: 'red' }}>
                                {'   '}
                                up to
                                {'  '}
                                {e?.selectionLimit > 0 ? e?.selectionLimit : 1}
                              </span>
                            ) : (
                              <span style={{ color: '#6e727cd9' }}>
                                {'   '}
                                up to{' '}
                                {e?.selectionLimit > 0 ? e?.selectionLimit : 1}
                              </span>
                            )}
                          </p>
                          {e.subProducts?.map((item: any, index: number) => (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div
                                key={item.id}
                                style={{
                                  color: '#474350',
                                  fontFamily:
                                    'Roboto, "Helvetica", Arial, sans-serif',
                                  marginTop: '-15px',
                                  marginLeft: '18px',
                                  wordWrap: 'break-word',
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedItems.some(
                                        x =>
                                          x.id === item.id &&
                                          x.parentId === e.id,
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          e.id,
                                          item.id,
                                          item.productId,
                                        )
                                      }
                                      value={item.id}
                                      disabled={
                                        (e.selectionLimit >= 1 &&
                                          selectedItems.filter(
                                            x => x.parentId === e.id,
                                          ).length >= e.selectionLimit &&
                                          !selectedItems.some(
                                            x =>
                                              x.id === item.id &&
                                              x.parentId === e.id,
                                          )) ||
                                        (!e.selectionLimit &&
                                          selectedItems.some(
                                            x =>
                                              x.parentId === e.id &&
                                              x.id !== item.id,
                                          ))
                                      }
                                      icon={
                                        eIndex === 0 ? (
                                          <CheckBoxOutlineBlankIcon fontSize="small" />
                                        ) : (
                                          <RadioButtonUncheckedIcon fontSize="small" />
                                        )
                                      }
                                      checkedIcon={
                                        eIndex === 0 ? (
                                          <CheckBoxIcon fontSize="small" />
                                        ) : (
                                          <CheckCircleIcon fontSize="small" />
                                        )
                                      }
                                    />
                                  }
                                  label={
                                    item?.name
                                      ? `${item?.name
                                          .charAt(0)
                                          ?.toUpperCase()}${item?.name.slice(
                                          1,
                                        )}`
                                      : ''
                                  }
                                  style={{
                                    fontSize: '14px',
                                    color: '#474350',
                                    marginBottom: '10px',
                                    fontFamily:
                                      'Roboto, "Helvetica", Arial, sans-serif',
                                    wordWrap: 'break-word',
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  fontFamily:
                                    'Roboto, "Helvetica", Arial, sans-serif',
                                  marginTop: '-5px',
                                  marginRight: '10px',
                                }}
                              >
                                $ {item?.price.toFixed(2)}
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                  </div>
                </div>
                <div style={{ marginTop: '-3px' }}>
                  <TextField
                    value={instructions}
                    onChange={handleInstructionsChange}
                    className={classes.InstructionField}
                    fullWidth
                  />
                </div>
                <p
                  style={{
                    color: '#6e727cd9',
                    fontFamily: 'Roboto, "Helvetica", Arial, sans-serif',
                    marginTop: '2px',
                    fontSize: '14px',
                  }}
                >
                  optional
                </p>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  marginTop="1rem"
                >
                  <Button
                    variant="contained"
                    disabled={product?.subCategories?.some(
                      (e: any) =>
                        e.required &&
                        !selectedItems.some(x => x.parentId === e.id),
                    )}
                    onClick={handleAddToBag}
                    style={{
                      width: '100%',
                      color: 'white',
                      margin: 'auto',
                      height: '55px',
                      borderRadius: '9px',
                      backgroundColor: '#ee3653',
                      fontWeight: 'bold',
                      cursor: product?.subCategories?.some(
                        (e: any) =>
                          e.required &&
                          !selectedItems.some(x => x.parentId === e.id),
                      )
                        ? 'not-allowed'
                        : 'pointer',
                    }}
                  >
                    Add to cart
                  </Button>
                </Box>
              </DialogContent>
            </div>
          </>
        )}
      </Dialog>

      <Dialog
        open={isCashDialog}
        onClose={onCashClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <div className="_cash_calculator">
          <div className="_cash_calculator_header">
            <Button
              className="_cash_calculator_back"
              onClick={async () => {
                setIsCashDialog(false);
              }}
            >
              <ArrowBack />
            </Button>
            <p className="_cash_calculator_title">
              Total Bill ${cashTotal.toFixed(2)}
            </p>
            <p className="_cash_calculator_subtitle">
              How much cash has the customer given you?
            </p>
          </div>

          <div className="_cash_calculator_body">
            <p className="_cash_calculator_amount">
              Entered Amount : $ {parseFloat(enteredAmount).toFixed(2)}
            </p>

            <div className="_cash_calculator_grid">
              <Button
                className="calculater-button"
                onClick={() => handleClick(1)}
              >
                1
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick(2)}
              >
                2
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick(3)}
              >
                3
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick(4)}
              >
                4
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick(5)}
              >
                5
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick(6)}
              >
                6
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick(7)}
              >
                7
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick(8)}
              >
                8
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick(9)}
              >
                9
              </Button>
              <Button
                className="calculater-button"
                onClick={() => setEnteredAmount('0')}
              >
                X
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick(0)}
              >
                0
              </Button>
              <Button
                className="calculater-button"
                onClick={() => handleClick('.')}
              >
                .
              </Button>
            </div>
            {isAmountError ? (
              <p className="_cash_calculator_error">
                ERROR: That amount is not enough for this order.
              </p>
            ) : null}
          </div>

          <div className="_cash_calculator_footer">
            <Button className="enter-button" onClick={calculateBill}>
              ENTER
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog open={showDiscounts} maxWidth="md" fullWidth>
        <DialogTitle className={classes.dialogTitle}>
          Available Discounts
        </DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl component="fieldset" fullWidth>
                <FormLabel style={{ fontSize: '1rem', color: '#474350' }}>
                  {promo.some(
                    p =>
                      p.type === 'ORDER' ||
                      (p.type === 'PRODUCT' &&
                        cartItems.some(ci => ci.productId === p.productId)),
                  )
                    ? 'Apply available discounts to order'
                    : 'No available promo codes'}
                </FormLabel>

                {/* Order Discounts */}
                {promo.some(p => p.type === 'ORDER') && (
                  <>
                    <h4 style={{ marginTop: '0.5rem' }}>Order Discounts</h4>
                    <FormGroup>
                      {promo
                        .filter(p => p.type === 'ORDER')
                        .map((option: any, index: number) => (
                          <FormControlLabel
                            key={`order-${index}`}
                            control={
                              <Checkbox
                                checked={selectedDiscount.includes(option.name)}
                                onChange={() =>
                                  handleDiscountSelection(option.name)
                                }
                              />
                            }
                            label={`${option.name} ${
                              option.price > 0
                                ? `($${option.price})`
                                : `(${option.percent}%)`
                            }`}
                          />
                        ))}
                    </FormGroup>
                  </>
                )}

                {/* Product Discounts */}
                {cartItems.map((item: any) => {
                  const applicable = promo.filter(
                    (p: any) =>
                      p.type === 'PRODUCT' && p.productId === item.productId,
                  );

                  if (applicable.length === 0) return null;

                  return (
                    <div key={item.productId}>
                      <h4>{item.name} Discounts</h4>
                      <FormGroup>
                        {applicable.map((option: any, index: number) => (
                          <FormControlLabel
                            key={`product-${item.productId}-${index}`}
                            control={
                              <Checkbox
                                checked={selectedDiscount.includes(option.name)}
                                onChange={() =>
                                  handleDiscountSelection(option.name)
                                }
                              />
                            }
                            label={`${option.name} ${
                              option.price > 0
                                ? `($${option.price})`
                                : `(${option.percent}%)`
                            }`}
                          />
                        ))}
                      </FormGroup>
                    </div>
                  );
                })}

                {/* Custom Discount */}
                {storeDiscount && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: '16px',
                    }}
                  >
                    <FormLabel style={{ fontSize: '1rem', color: '#474350' }}>
                      Add Custom Discount
                    </FormLabel>
                    <button
                      className="_cart_item_add"
                      style={{ marginLeft: '12px' }}
                      onClick={() => {
                        setShowDiscounts(false);
                        setDiscountAmount(0);
                        setShowCustomDiscounts(true);
                      }}
                    >
                      +
                    </button>
                  </div>
                )}

              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogActionsRow}>
          <Button
            className={classes.cancleDiscountButton}
            onClick={() => setShowDiscounts(false)}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            className={classes.addToOrderButton}
            onClick={onClickAddPromo}
            disabled={selectedDiscount.length === 0 && promo.length > 0}
          >
            Add to order
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={showCustomDiscounts} maxWidth="md" fullWidth>
        <DialogTitle className={classes.dialogTitle}>
          Add Custom Discount
        </DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl component="fieldset" fullWidth>
                <TextField
                  className="generic-dialog__field"
                  name="discountAmount"
                  type="string"
                  onChange={(e: any) =>
                    customDiscountHandleChange('amount', e.target.value)
                  }
                  label="Discount Amount"
                  value={customAmount}
                  autoComplete="off"
                  inputProps={{
                    min: '0',
                    step: 0.01,
                    type: 'number',
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
                <TextField
                  className="generic-dialog__field"
                  name="discountPercentage"
                  type="number"
                  onChange={(e: any) =>
                    customDiscountHandleChange('percentage', e.target.value)
                  }
                  label="Discount Percent"
                  value={customPercentage}
                  autoComplete="off"
                  inputProps={{
                    min: '0',
                    step: 0.01,
                    type: 'number',
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogActionsRow}>
          <Button
            className={classes.cancleDiscountButton}
            onClick={() => {
              setShowCustomDiscounts(false);
            }}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            className={classes.addToOrderButton}
            onClick={handleCustomDiscount}
          >
            Add to order
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showCustomProduct}
        maxWidth="sm"
        fullWidth
        PaperProps={{ style: { maxWidth: '720px' } }}
      >
        <DialogTitle className={classes.dialogTitle}>
          Add Custom Product
        </DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          <CustomProduct
            storeContext={location?.state.storeContext}
            venue={venueData}
            fetchProducts={handleFetchProducts}
            handleFetchProductsFalse={handleFetchProductsFalse}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog open={outOfStockPopUp} maxWidth="sm">
        <DialogTitle>
          Following Products are now out of Stock and Marked Inactive
        </DialogTitle>
        <DialogContent>
          <div className="dialogue-box">
            <ul style={{ listStyle: 'inside maroon circle' }}>
              {outOfStockItems.map((product, index) => (
                <li key={index}>{product}</li>
              ))}
            </ul>
            <div
              style={{
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Button
                onClick={() => {
                  setOutOfStockPopUp(false);
                  setOutOfStockItems([]);
                }}
                className={classes.closeButton}
                style={{
                  maxWidth: '130px',
                  maxHeight: '40px',
                  minWidth: '129px',
                  minHeight: '40px',
                }}
                color="primary"
              >
                close
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={showNotePopup}
        maxWidth="sm"
        fullWidth
        onClose={() => {
          setNote('');
          setShowNotePopup(false);
        }}
      >
        <DialogTitle className={classes.dialogTitle}>Add Note</DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          <FormControl component="fieldset" fullWidth>
            <TextField
              className="generic-dialog__field"
              name="note"
              type="text"
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              onChange={(e: any) => setNote(e.target.value)}
              label="Note"
              value={note}
              autoComplete="off"
            />
          </FormControl>
        </DialogContent>
        <DialogActions className={classes.dialogActionsRow}>
          <Button
            className={classes.cancleDiscountButton}
            onClick={() => {
              setNote('');
              setShowNotePopup(false);
            }}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            className={classes.addToOrderButton}
            onClick={() => {
              setNote(note);
              setShowNotePopup(false);
            }}
          >
            Add to order
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showCartPopup}
        onClose={() => {
          setShowCartPopup(false);
        }}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ textAlign: 'center' }}
          >
            you can only be logged into one terminal at a time with a user and
            you are currently logged in. You have to remove existing cart.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="outlined"
            onClick={onDeleteCart}
            style={{
              backgroundColor: '#EE3653',
              color: 'white',
              border: 'none',
            }}
          >
            Clear Cart
          </Button>
          <Button
            onClick={() => {
              setShowCartPopup(false);
            }}
            color="primary"
            variant="outlined"
          >
            No Go Back
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PosTerminal;
